function initCookieDisclaimer(){

    var cookieconsentModal = new bootstrap.Modal(document.getElementById('cookieconsent'), {
        keyboard: false,
      backdrop: 'static', 
      });
     
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
        }
        return false;
    }

    
				
    var exdays = 15;
    var $acceptAll =        document.querySelector('.btn-acceptAll');
    //var $acceptPart =       document.querySelector('.btn-AcceptPart');
     
    
    
    
    var cookieCheckTechnical = document.querySelector('#cookieconsent #cookieCheckTechnical');
    //var cookieCheckStatsitik = document.querySelector('#cookieconsent  #cookieCheckStatsitik');
    
    
     setTimeout(function(){
          cookieCheckTechnical.checked = true;
      },1000);


    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {

        return c.substring(name.length, c.length);

        }
        }
        return ""; 
    }

    function injectScript(source) {
        
        var Script = document.createElement("script");
        var inlineScript = document.createTextNode(source);
        Script.appendChild(inlineScript); 
        document.getElementsByTagName('head')[0].appendChild(Script);

    

    }
    
    function technicalHook() {
        
        
    }
    
    function statsitikHook() {
        
        
       // loadGAonConsent();
      
    }
    
    function komfortHook() {
        
    
        
    }
    
    function checkCookie() {
        
        var cookieCheckTechnicalVal = getCookie('cookieCheckTechnicalVal');
        var cookieCheckStatsitikVal = getCookie('cookieCheckStatsitikVal');
        
        if (cookieCheckTechnicalVal == 'true') {
            
            
            technicalHook();
            cookieCheckTechnical.checked = true;
        } else {
            
            cookieCheckTechnical.checked = false;
        }
    
        /*
        if (cookieCheckStatsitikVal == 'true') {
            
            statsitikHook();
            cookieCheckStatsitik.checked = true;
            
        } else {
            
            cookieCheckStatsitik.checked = false;
            
            
        }
        */
     
        
        
        
        
    }
    
   
    /*
    $acceptPart.addEventListener("click",function(e){
        
        
        var cookieCheckTechnicalVal 	= false;
        var cookieCheckStatsitikVal 	= false;
        
        
        
        
        
        
        
        
        if (cookieCheckTechnical.checked) {
            
            cookieCheckTechnicalVal = true;
        }
        
 
    
        if (cookieCheckStatsitik.checked) {
            
            cookieCheckStatsitikVal = true;
        }
   
        
        
        
         setCookie('cookieCheckTechnicalVal', cookieCheckTechnicalVal, exdays);
         setCookie('cookieCheckStatsitikVal', cookieCheckStatsitikVal, exdays);
        
         setCookie('cookieConsent', true, exdays);
         location.reload();
        
        cookieconsentModal.hide();
        
        
        
    },false);
    
    */
    $acceptAll.addEventListener("click",function(e){
        
        
        var cookieCheckTechnicalVal 	= true;
        //var cookieCheckStatsitikVal 	= true;
        
        
        
         setCookie('cookieCheckTechnicalVal', cookieCheckTechnicalVal, exdays);
         //setCookie('cookieCheckStatsitikVal', cookieCheckStatsitikVal, exdays);
        
         setCookie('cookieConsent', true, exdays);
        
        cookieconsentModal.hide();
        
        location.reload();
        
    },false);
    
    
    
    
    checkCookie();
    
    
    if (getCookie('cookieConsent').length) {
        
        
        
    } else {
        
         cookieconsentModal.show();
        
    }
    
    
    


} 

